<template>
	<v-dialog ref="dialog" v-model="modal" persistent width="290px">
		<template v-slot:activator="{ on }">
			<v-text-field
				:value="momentDate"
				class="ml-4"
				@click:prepend-inner="modal = true"
				prepend-inner-icon="mdi-calendar-month"
				single-line
				hide-details
				readonly
				v-on="on"
			/>
		</template>

		<v-card :loading="loading">
			<v-date-picker
				first-day-of-week="1"
				:value="date"
				:picker-date="month"
				:disabled="loading"
				:no-title="true"
				:day-format="dayFormat"
				:events="events"
				@click:date="clickDate"
				@update:picker-date="clickMonth"
			/>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
	name: 'MonthCalendar',

	computed: {
		...mapGetters({
			date: 'bookings/date',
			month: 'bookings/month'
		}),
		momentDate() {
			return this.date ? this.$moment(this.date).format('dddd, Do MMMM') : ''
		}
	},

	data() {
		return {
			loading: false,
			modal: false,
			events: {}
		}
	},

	watch: {
		month() {
			this.getBookings()
		},
		modal() {
			if (this.modal) {
				this.getBookings()
			}
		}
	},

	methods: {
		...mapMutations({
			saveDate: 'bookings/SAVE_DATE',
			saveMonth: 'bookings/SAVE_MONTH'
		}),
		dayFormat(date) {
			return new Date(date).getDate(date)
		},
		clickDate(date) {
			this.saveDate(date)
			this.modal = false
		},
		clickMonth(date) {
			this.saveMonth(date)
		},
		async getBookings() {
			this.events = {}
			this.loading = true
			let { data } = await this.$http.get(`bookings/month/${this.month}`)

			this._.forEach(data, event => {
				this.events[event.book_dt] = 'red'
			})
			this.loading = false
		}
	}
}
</script>
